<script setup>
import {ref, watch} from 'vue';
import SuccessModal from './SuccessModal.vue';
import QuestionDisapprovalModal from "@/components/approval-center/modals/QuestionDisapprovalModal.vue";
import PublishConfirmationModal from "@/components/approval-center/modals/PublishConfirmationModal.vue";
import FixPanelIcon from "@/components/approval-center/partials/ui/FixPanelIcon.vue";

const questionValue = defineModel('question', {
  type: String,
  required: true,
});

const answerValue = defineModel('answer', {
  type: String,
  required: true,
});

const emit = defineEmits(['close', 'confirm']);

const questionInput = ref('');
const answerInput = ref('');

watch(() => questionValue.value, (newValue) => (questionInput.value = newValue), { immediate: true });
watch(() => answerValue.value, (newValue) => (answerInput.value = newValue), { immediate: true });

const showSuccessModal = ref(false);
const showConfirmationModal = ref(false);

const handlePreConfirm = () => {
  showConfirmationModal.value = true;
}

const handleConfirm = () => {
  showConfirmationModal.value = false;
  emit('update:question', questionInput.value);
  emit('update:answer', answerInput.value);
  emit('confirm');
  showSuccessModal.value = true;
};
</script>

<template>
  <QuestionDisapprovalModal
    v-if="!showSuccessModal && !showConfirmationModal"
    v-model:question="questionInput"
    v-model:answer="answerInput"
    @close="emit('close')"
    @confirm="handlePreConfirm"
  />

  <PublishConfirmationModal
    v-else-if="showConfirmationModal"
    :input="questionInput"
    :secondary-input="answerInput"
    @back="showConfirmationModal = false"
    @confirm="handleConfirm"
  >
    <template #label>
      <FixPanelIcon icon-path="icons/user-question" />
      Question
    </template>

    <template #secondaryLabel>
      <FixPanelIcon icon-path="icons/user-answer" />
      Answer
    </template>
  </PublishConfirmationModal>

  <SuccessModal
    v-else
    @close="emit('close')"
  />
</template>
